import {dbDelete, dbGet, dbPatch, dbPost} from "utils/ajaxUtils";
import {arrayOfSorts, clone} from 'utils/DBUtils';
import {dbPostForm} from "../utils/ajaxUtils";
import {isNoU} from "../utils/DBUtils";

export const Types = {
    Article: "Article",
    ArticleBlockQuote: "ArticleBlockQuote",
    MenuContent: "MenuContent",
    MenuContentItem: "MenuContentItem",
    ArticleBodyCopy: "ArticleBodyCopy",
    ArticleEmbedContent: "ArticleEmbedContent",
    ArticleImage: "ArticleImage",
    ArticleImageComparison: "ArticleImageComparison",
    ArticleLinkButton: "ArticleLinkButton",
    ArticleSubhead: "ArticleSubhead",
    Analytics: "Analytics",
    AuthenticatedUser: "AuthenticatedUser",
    BestSellingStoreItem: "BestSellingStoreItem",
    BreakFooterLink: "BreakFooterLink",
    CampaignRetailerItem: "CampaignRetailerItem",
    CampaignStoreEscrow: "CampaignStoreEscrow",
    CampaignStoreStock: "CampaignStoreStock",
    Checklist: "Checklist",
    ChecklistItemGroup: "ChecklistItemGroup",
    CustomHtmlStep: "CustomHtmlStep",
    CustomJsonStep: "CustomJsonStep",
    Beaker2Step: "Beaker2Step",
    CompleteStep: "CompleteStep",
    DefaultUGCCampaign: "DefaultUGCCampaign",
    DailybreakJob: "DailybreakJob",
    DragAndDropCard: "DragAndDropCard",
    DragAndDropCardStack: "DragAndDropCardStack",
    HomepageLayout: "HomepageLayout",
    HomepageSection: "HomepageSection",
    HomepageColumn: "HomepageColumn",
    HomepageHeroSection: "HomepageHeroSection",
    HomepageBreakGroup: "BreakCardGroup",
    HomepageMessageBar: "HomepageMessageBar",
    Image: "Image",
    LinkCard: "LinkCard",
    OriginalImage: "OriginalImage",
    Filter: "Filter",
    Break: "Break",
    BreakSiteMeta: "BreakSiteMeta",
    BreakTag: "BreakTag",
    Category: "Category",
    Campaign: "Campaign", // aka MasterCampaign, a virtual resource like Challenge
    Challenge: "Challenge",
    ChecklistResult: "ChecklistResult",
    DropdownButton: "DropdownButton",
    DropdownButtonLink: "DropdownButtonLink",
    BreakStep: "BreakStep",
    FeaturedManager: "FeaturedManager",
    Filtering: "Filtering",
    FilteringDropdown: "FilteringDropdown",
    FilteringDropdownItem: "FilteringDropdownItem",
    FilteringResult: "FilteringResult",
    FilteringResultBlockQuote: "FilteringResultBlockQuote",
    FilteringResultBodyCopy: "FilteringResultBodyCopy",
    FilteringResultContent: "FilteringResultContent",
    FilteringResultEmbed: "FilteringResultEmbed",
    FilteringResultImage: "FilteringResultImage",
    FilteringResultLinkButton: "FilteringResultLinkButton",
    GalleryStep: "GalleryStep",
    GroceryChecklist: "GroceryChecklist",                       //individual instance of grocery checklist for itemized checklists
    GroceryChecklistItem: "GroceryChecklistItem",             //Each checkbox inside grocery checklist
    GroceryDropdownButton: "GroceryDropdownButton",
    GroceryDropdownButtonLink: "GroceryDropdownButtonLink",
    GroceryStep: "GroceryStep",
    LeadGen: "LeadGen",
    LeadGenAlert: "LeadGenAlert",
    LeadGenConfirmation: "LeadGenConfirmation",
    LeadGenField: "LeadGenField",
    Group: "Group",
    Listicle: "Listicle",
    ListicleContent: "ListicleContent",
    ListicleAddToCalendar: "ListicleAddToCalendar",
    ListicleBlockQuote: "ListicleBlockQuote",
    ListicleBodyCopy: "ListicleBodyCopy",
    ListicleEmbedContent: "ListicleEmbedContent",
    ListicleImage: "ListicleImage",
    ListicleImageComparison: "ListicleImageComparison",
    ListicleItem: "ListicleItem",
    ListicleLinkButton: "ListicleLinkButton",
    ListicleOldBodyCopy: "ListicleOldBodyCopy",
    ListicleSubhead: "ListicleSubhead",
    MediaUploadCampaign: "MediaUploadCampaign",
    MediaUploadConfirmation: "MediaUploadConfirmation",
    MemoryMatchGame: "MemoryMatchGame",
    MemoryMatchCard: "MemoryMatchCard",
    NgcEndpoint: "NgcEndpoint",
    OverlayImage: "OverlayImage",
    PersonalityQuiz: "PersonalityQuiz",
    PersonalityQuizAnswer: "PersonalityQuizAnswer",
    PersonalityQuizResult: "PersonalityQuizResult",
    PersonalityQuizQuestion: "PersonalityQuizQuestion",
    PointHistory: "PointHistory",
    Poll: "Poll",
    PollQuestion: "PollQuestion",
    PollAnswer: "PollAnswer",
    Prize: "Prize",
    Product: "Product", // review step
    ProductPanel: "ProductPanel",   // poll step
    ProductPanelProduct: "ProductPanelProduct", // poll step
    PrizeEntry: "PrizeEntry",
    PrizeboothOrder: "PrizeboothOrder",
    PublishedBreak: "PublishedBreak",
    PublishedPrize: "PublishedPrize",
    PublishLogReport: "PublishLogReport",
    ReceiptVerificationCampaign: "ReceiptVerificationCampaign",
    ReceiptCampaignDetailedInstruction: "ReceiptCampaignDetailedInstruction",
    ReceiptCampaignReminderInstruction: "ReceiptCampaignReminderInstruction",
    ReceiptCampaignReward: "ReceiptCampaignReward",
    ReceiptCampaignStepInstruction: "ReceiptCampaignStepInstruction",
    ReferralLink: "ReferralLink",
    ReferralLinks: "ReferralLinks",
    RelatedBreak: "RelatedBreak",
    Retailer: "Retailer",
    RetailerItem: "RetailerItem",
    Review: "Review",
    SampleReview: "SampleReview",
    Site: "Site",
    SpotTheDifferenceGame: "SpotTheDifferenceGame",
    SpotTheDifferenceDifference: "SpotTheDifferenceDifference",
    SpotTheDifferenceInstruction: "SpotTheDifferenceInstruction",
    SpotTheDifferenceLevel: "SpotTheDifferenceLevel",
    StepInstruction: "StepInstruction",
    StoreAccount: "StoreAccount",
    StoreCatalog: "StoreCatalog",
    StoreEscrow: "StoreEscrow",
    StoreOrder: "StoreOrder",
    StoreFinderStep: "StoreFinderStep",
    StoreLocationFile: "StoreLocationFile",
    StoreStock: "StoreStock",
    Survey: "Survey",
    SurveyUserAnswer: "SurveyUserAnswer",
    TextTrivia: "TextTrivia",
    TextTriviaQuestion: "TextTriviaQuestion",
    TextTriviaAnswer: "TextTriviaAnswer",
    TextTriviaResult: "TextTriviaResult",
    Palette: "Palette",
    UgcCampaign: "UgcCampaign",
    UGCCampaignInstruction: "UGCCampaignInstruction",
    UGCImageLayer: "UGCImageLayer",
    UGCSubmission: "UGCSubmission",
    UGCSubmissions: "UGCSubmissions",
    UGCReceiptSubmission: "UGCReceiptSubmission",
    User: "User",
    VideoStep: "VideoStep",
    Winner: "Winner",
    WinnerStory: "WinnerStory",
    Tag: "Tag",
};

export const AvailableSteps = [
    "ArticleStep",
    "ChecklistStep",
    "CompleteStep",
    "CustomHtmlStep",
    "CustomJsonStep",
    "Beaker2Step",
    "DragAndDropStep",
    "FilteringStep",
    "GalleryStep",
    "GroceryStep",
    "LeadGenStep",
    "ListicleStep",
    "MediaUploadStep",
    "MemoryMatchStep",
    "PersonalityQuizStep",
    "PinterestStep",
    "PollStep",
    "PuzzleStep",
    "ReviewStep",
    "ReceiptVerificationStep",
    "ReferralStep",
    "SpotTheDifferenceStep",
    "StoreFinderStep",
    "TextTriviaStep",
    "PhotoStep",
    "VideoStep"
];

const transformResourceHierarchy = (resourceHierarchy) => {
    let ids = {};
    for (let resource of resourceHierarchy) {
        // Clone as BreakStep id if its a step resource
        if (AvailableSteps.indexOf(resource.type) > -1) {
            ids.breakStepId = {
                type: Types.BreakStep,
                id: resource.id
            }
        } else {
            let key = resource.type;
            key = key.slice(0, 1).toLowerCase() + key.slice(1) + "Id";
            ids[key] = clone(resource);
        }
    }
    return JSON.stringify(ids);
};

const objectToFieldValueArray = (obj) => {
    let ary = [];
    for (let key of Object.keys(obj)) {
        ary.push({
            field: key,
            value: obj[key]
        })
    }
    return ary;
};

/*
    Resource methods
 */
export const create = (type, data, resourceIds) => dbPost(`resource/${type.toLowerCase()}`, {
    args: JSON.stringify(data),
    resourceIdsJson: transformResourceHierarchy(resourceIds)
});

export const update = (type, id, data, resourceIds) => dbPost(`resource/${type.toLowerCase()}/${id}`, {
    args: JSON.stringify(data),
    resourceIdsJson: transformResourceHierarchy(resourceIds)
});

export const upload = (type, file, args, resourceIds) => dbPostForm(`resource/${type.toLowerCase()}/upload`, {
    file: file,
    args: JSON.stringify(args),
    resourceIdsJson: transformResourceHierarchy(resourceIds)
});

// Native (non-Filestack) image upload, hitting the same `resource/{type}/upload` route as
// `upload` above, but for the `Image` resource specifically, and shaped for the native
// picker/crop flow in pages/Images: `file` is present for a device (pre-cropped) upload,
// and absent (only `args.mediaUrl`) for a URL-sourced one -- the server fetches the bytes
// itself in that case, so there is nothing to append as a `file` part.
export const uploadNativeImage = (file, args, resourceIds) => {
    const data = {
        args: JSON.stringify(args),
        resourceIdsJson: transformResourceHierarchy(resourceIds)
    };
    if (!isNoU(file)) {
        data.file = file;
    }
    return dbPostForm(`resource/${Types.Image.toLowerCase()}/upload`, data);
};

export const synchronize = (platform, resourceId) => create('break/synchronize', {platform}, [resourceId]);

export const deleteResource = (type, id, resourceIds, data) => dbDelete(`resource/${type.toLowerCase()}/${id}`, {
    ...(data ? {args: JSON.stringify(data)} : {}),
    resourceIdsJson: transformResourceHierarchy(resourceIds)
});

export const saveField = (type, id, field, value, resourceHierarchy, data) => dbPatch(`resource/${type.toLowerCase()}/${id}`, {
    args: JSON.stringify(data || {}),
    field: field,
    value: Array.isArray(value) ? JSON.stringify(value) : value,
    resourceIdsJson: transformResourceHierarchy(resourceHierarchy)
});

export const save = (type, data, resourceIds = []) => dbPatch(`resource/${type.toLowerCase()}`, {
  args: JSON.stringify(data),
  resourceIdsJson: transformResourceHierarchy(resourceIds)
});

export const saveChangelist = (type, id, changelist, resourceHierarchy, data) => dbPatch(`resource/${type.toLowerCase()}/${id}`, {
    args: JSON.stringify(data || {}),
    changelist: Array.isArray(changelist) ? changelist : objectToFieldValueArray(changelist),
    resourceIdsJson: transformResourceHierarchy(resourceHierarchy)
});

export const copy = (type, data, resourceIds) => dbPost(`resource/${type.toLowerCase()}/clone`, {
    args: JSON.stringify(data),
    resourceIdsJson: transformResourceHierarchy(resourceIds)
});

export const getPage = (type, count, page, sortOptions, filterOptions, args) => dbGet(`resource/${type.toLowerCase()}`, {
    count: count,
    page: page,
    sorts: arrayOfSorts(sortOptions.sorts),
    namedFilters: filterOptions.namedFilters,
    filters: filterOptions.filters,
    args: isNoU(args) ? null : JSON.stringify(args)
});

export const getById = (type, id) => dbGet(`resource/${type.toLowerCase()}/${id}`, {});

export const query = (type, sortOptions, filterOptions, params = {}) => dbGet(`resource/${type.toLowerCase()}/query`, {
    sorts: arrayOfSorts(sortOptions.sorts),
    filters: filterOptions.filters,
    namedFilters: filterOptions.namedFilters,
    ...params
});

// Alias until full refactor can be done and tested
export const getAll = (type, sortOptions, filterOptions, params) => query(type, sortOptions, filterOptions, params);

export const searchResources = (type, query, sortOptions, filterOptions, limit) => dbGet(`resource/${type.toLowerCase()}/search`, {
    query,
    sorts: arrayOfSorts(sortOptions.sorts),
    filters: filterOptions.filters,
    namedFilters: filterOptions.namedFilters,
    limit
});

export const download = (type, args) => dbGet(`resource/${type.toLowerCase()}/download`, {
    args: JSON.stringify(args)
});

export const downloadQuery = (type, sortOptions, filterOptions) => dbGet(`resource/${type.toLowerCase()}/download`, {
    sorts: arrayOfSorts(sortOptions.sorts),
    filters: filterOptions.filters
});

/*
    Info methods
 */

export const getAllResourceInfo = () => dbGet(`info/resource`, {});
export const getResourceInfo = (type) => dbGet(`info/resource/${type}`, {});



// WEBPACK FOOTER //
// ./public/api/resources.js